import './ficheetudiant.css';
import React from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const Ficheetudiant = () => {
  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className='messageriebox'>
        <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Profile</p>
        <hr/>
      <Tabs defaultActiveKey="1" onChange={onChange} className='TAB'  >
        <TabPane tab="Fiche étudiant" key="1" >
        <form >

    <div className="row">
      <div className="col-25">
        <label for="fname">Nom et Prénom</label>
      </div>
      <div className="col-75">
      <label for="fname">AMMAR Dalel</label>

      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">CIN</label>
      </div>
      <div className="col-75">
      <label for="fname">14036001</label>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Sexe</label>
      </div>
      <div className="col-75">
      <label for="fname">féminin</label>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Adresse</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname" value="ksar hellel" placeholder="votre adresse"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Téléphone</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname"  value="24758444" placeholder="votre téléphone"/>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">E-mail</label>
      </div>
      <div className="col-75">
        <input className="textstage" type="text" id="lname" name="lastname"  value="dalelammar@gmail.com" placeholder="votre site web / page facebook"/>
      </div>
    </div>

    <div className="row">
      <div className="col-25">
        <label for="lname">Diplome</label>
      </div>
      <div className="col-75">
      <label for="fname">Ingénieur en informatique</label>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Niveau</label>
      </div>
      <div className="col-75">
      <label for="fname">1</label>
      </div>
    </div>
    <div className="row">
      <div className="col-25">
        <label for="lname">Groupe</label>
      </div>
      <div className="col-75">
      <label for="fname">TD2</label>
      </div>
      </div>

    <div className="row inputsubmitstage">
      <input className="submitform" type="submit" value="Metre à jour"/>
    </div>
    </form >
     
        </TabPane>
        <TabPane tab="Photo d'identité" key="2">
       
    <img
    width={200}
    src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"/>

        </TabPane>
      </Tabs>
    </div>
  );
};

export default Ficheetudiant;
